import { render, staticRenderFns } from "./editservice.vue?vue&type=template&id=7cb2528f"
import script from "./editservice.vue?vue&type=script&lang=js"
export * from "./editservice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports